/**
 * 初始化监控中的用户 ID
 * @param currentUser
 * @returns
 */
export const initUserId = (currentUser) => {
  // 当前用户信息为空则中止
  if (!currentUser) return;

  const { id, name, en_name, department } = currentUser || {};

  // 未正确获取到有效信息时，则中止
  if (name || en_name) {
    const user_id = `${id}:${department?.name} ${name || en_name}`;

    window.aliLogger.setConfig({
      setUsername() {
        return user_id;
      },
    });

    window.lf_apm('init', window.APM_TRACKED_ID, {
      user_id: user_id || localStorage.getItem('QDESK_USER_NAME') || 'anonymous',
      enableUserId: true,
      enableSdkVersion: true,
      routeMode: 'history',
      plugins: {
        pv: true,
        js_error: true,
        http: true,
      },
      sampleRate: {
        pv: 1,
        performance: 1,
        performance_timing: 1,
        resource: 1,
        js_error: 1,
        http: 1,
      },
      ignoreErrors: {
        js_error: [
          /ResizeObserver loop limit exceeded/,
          /ResizeObserver loop completed with undelivered notifications/,
          /Script error./,
          /Network Error/,
          /CanceledError/,
          /canceled/,
          /【UnhandledRejection】updateEmailTicket is not defined/,
          /【UnhandledRejection】邮箱验证失败/,
          /【TypeError】Failed to fetch/,
          /【SyntaxError】Uncaught SyntaxError/,
          /【AxiosError】Request failed with status code 401/,
          /【ChunkLoadError】Uncaught ChunkLoadError/,
        ],
      },
    });

    window.lfq('init', window.TRACKED_ID, {
      send_page_view: false, // page view 事件，页面加载时自动触发
      send_scroll: true, // scroll 事件，页面滚动到底部时触发
      send_search_result: true, // search_result 事件，当用户看到搜索结果页时触发
      // send_outbound: true, // outbound 事件，当用户点击外链时触发
      send_performance: true, // 自动触发 performance 事件
      user_id: user_id || localStorage.getItem('QDESK_USER_NAME') || 'anonymous', // 用户 ID
    });
  }
};
